import React, { useEffect } from 'react';
import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import { ArrowBack } from '@material-ui/icons';
import { getJobTitle } from 'controllers/dashboard/getTopBarData';
import { useState } from 'react';

const useStyles = makeStyles(() => ({
  topBar: {
    height: 52,
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    margin: '52px 0 0',
    background: '#fbfbfb',
  },
  jobTitleContainer: {
    height: '100%',
  },
  jobTitleText: {
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.24px',
    lineHeight: 1.36,
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  tabsAndSearchContainer: {
    paddingLeft: '16px',
  },
  tabsContainer: {
    marginBottom: '4px',
  },
  tabText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.36,
    textTransform: 'none',
  },
  talentCountText: {
    backgroundColor: '#777D83',
    color: '#ffffff',
    padding: '1px 10px',
    borderRadius: '3px',
    fontSize: '0.75em',
    marginLeft: '5px',
  },
}));

const TopBar = () => {
  const classes = useStyles();
  const [jobRole, setJobrole] = useState('');
  const params = useParams();
  const history = useHistory();
  const jobId = params.id || '';

  if (!jobId) {
    history.goBack();
  }

  useEffect(() => {
    const fetchJobData = async () => {
      const title = await getJobTitle(jobId);
      setJobrole(title);
    };

    fetchJobData();
  }, [jobId]);

  const onNavigate = (link) => () => {
    history.push(link);
  };

  return (
    <Grid container classes={{ root: classes.topBar }}>
      <Grid item xs={2}>
        <Box
          display="flex"
          alignItems="center"
          classes={{ root: classes.jobTitleContainer }}
        >
          <Tooltip arrow title="Go Back">
            <IconButton onClick={onNavigate('/screened-pipe')} size="small">
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title="Click to view Job">
            <Typography
              classes={{ root: classes.jobTitleText }}
              onClick={onNavigate(`/job/${jobId}`)}
            >
              {jobRole}
            </Typography>
          </Tooltip>
        </Box>
      </Grid>
      <Grid item xs={10}>
        <Grid container classes={{ root: classes.tabsAndSearchContainer }}>
          <Grid item xs={4} classes={{ root: classes.tabsContainer }}>
            <Tabs
              value={0}
              indicatorColor="primary"
              textColor="primary"
              onChange={onNavigate(`/screened-pipe/${jobId}`)}
              aria-label="Nav Tabs"
              classes={{ flexContainer: classes.tabsContainer }}
            >
              <Tab
                label={
                  <Typography classes={{ root: classes.tabText }}>
                    Dashboard
                  </Typography>
                }
              />
              <Tab
                label={
                  <Typography classes={{ root: classes.tabText }}>
                    Applicants
                    {/* {pipeline.totalLeads ? (
                      <span className={classes.talentCountText}>
                        {pipeline.totalLeads}
                      </span>
                    ) : (
                      ''
                    )} */}
                  </Typography>
                }
              />
            </Tabs>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TopBar;
